import { render, staticRenderFns } from "./TxDensityChart.vue?vue&type=template&id=1d7b6dc6"
import script from "./TxDensityChart.vue?vue&type=script&lang=js"
export * from "./TxDensityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports